import { FC, JSX, useState } from 'react';

import { Flex, Form } from 'antd';

import useIsMobile from '@/hooks/useIsMobile';

import styles from './DebtsTable.module.scss';
import { DebtsTableConfig } from './DebtsTableConfig';
import { DebtsDesktopTable, DebtsMobileTable } from './components';
import { useGetDebtsTableColumns } from './hooks/useGetDebtsTableColumns';

import { ConfirmationModal } from '@/components';

export const DebtsTable: FC = (): JSX.Element => {
	const isMobile = useIsMobile();

	const [isDeleteModalOpen, setIsDeleteModalOpen] = useState<number | null>(null);

	const columns = useGetDebtsTableColumns({ setIsDeleteModalOpen });

	return (
		<DebtsTableConfig>
			<Flex className={styles['container']} vertical>
				<Flex className={styles['table-container']} vertical>
					<Form.List name="businessDebts">
						{(fields, { add, remove }) => {
							const cols = columns(remove);

							const handleAdd = (): void => {
								add();
							};

							return (
								<>
									{isMobile ? (
										<DebtsMobileTable add={handleAdd} columns={cols} dataSource={fields} />
									) : (
										<DebtsDesktopTable add={handleAdd} columns={cols} fields={fields} />
									)}
									<ConfirmationModal
										cancelButtonProps={{
											onClick: () => setIsDeleteModalOpen(null),
											children: 'Cancel',
										}}
										open={isDeleteModalOpen !== null}
										submitButtonProps={{
											onClick: () => {
												remove(isDeleteModalOpen as number);
												setIsDeleteModalOpen(null);
											},
											children: 'Delete',
										}}
										onClose={() => {
											setIsDeleteModalOpen(null);
										}}
									>
										Are you sure you want to permanently delete this debt entry?
									</ConfirmationModal>
								</>
							);
						}}
					</Form.List>
				</Flex>
			</Flex>
		</DebtsTableConfig>
	);
};
